import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './card-detail.html';

@Component({
  controllerAs: 'cardDetail',
  template
})

export default class CardDetail {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'toaster',
    '$stateParams',
    'spinnerService',
    'orderService',
    'authService',
    '$window', 'APP' , '$q'
  ];

  constructor($scope, $ngRedux, $state, $toaster, $stateParams, $spinner, $order, $auth, $window, APP, $q) {
    const disconnect = $ngRedux.connect(this.mapState)(this);

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$order = $order;
    this.$toaster = $toaster;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$window = $window;
    this.$auth = $auth;
    this.APP = APP;
    this.$q = $q;
    this.$spinner = $spinner;
    this.isAllowedToAdd = true;
    this.isAllowedToRemove = true;
    this.isAllowToPayOnlyWithGiftCards = false;
    this.giftCardNumbers = [];
    this.totalGiftAmount = 0.00;
    this.waitUntilVerify = false;
    this.cardNumberRegEx = "/^[0-9]{1,5}$/";
    this.isMiscelleneousCategory = 4;
    this.showHeartLandPage = false;
    this.heartand_Approval = "APPROVAL";
    this.isErplyStore = false;
    this.allowErplyZeroDollarTrasaction = false;

    let promise1 = $order.getCartDetail(false);
    this.toDecimalPlaces = 2;
    $spinner.show('appSpinner');
    $order.isGiveXAvailable()
      .then(success => {
        this.isGiveXAvailable = success.data.givexAvaible;
      })
      .catch(err => {
        this.isGiveXAvailable = false;
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => {});

    let promise3 = $auth.isGuestLogin() ? $auth.getGuestUserProfile() : $auth.getUserProfile();
    if (!$auth.isGuestLogin()) {
      $order.getPaymentInfo()
        .then(success => {
          if (success.data.length > 0) {
            this.cardId = success.data[0].id;
          }
        })
        .catch(err => {
          this.$auth.printCustomerGenericLogs(err);
        })
        .finally(() => {
          } 
        );
    }
    $order.getOrderAmount(this.$stateParams.orderId)
      .then(success => {
        this.orderAmount = success.data;
      }).catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      });

      $order.getPaymentKeys().then(success => {
      this.paymentType = success.data.paymentType;
      this.paymentGlobalKey = success.data.globalKey;
      this.isErplyStore = success.data.isErplyStore;
    })
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      });

    let promises = [promise1, promise3];
    $q.all(promises)
      .then(() => {
        if ($auth.isGuestLogin()) {
          this.profile = this.guestprofile;
        }
        this.canZeroDollarErplyTransaction();
      }).catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => {
        $spinner.hide('appSpinner');
      }
    );

    $scope.$on('$destroy', disconnect);

    this.giftCardDetails = [];
    this.giftCardDetails.push(this.getEmptyCardDetails());
    this.MaxGiftCardsDetails = 3;
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      canSaveCard : state.auth.profile.saveCard,
      cardInfo: state.order.paymentInfo,
      cartDetail: state.order.cartDetail,
      guestprofile: state.auth.guestprofile
    };
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  submit() {
    var $ctrl = this;
    // Un comment when terms and condition button changes needed
    // if(!this.agreement){
    //   this.$toaster.pop('success', 'Please Select Terms and Conditions');
    //   return;
    // }
    if (!this.cardId && !this.isAllowToPayOnlyWithGiftCards) {
      // this.$spinner.show('appSpinner');
      this.$toaster.pop('success', 'Please select Card to continue.');
      return;
    }

    this.isCallingAPI = true;

    var giftCardsRequest = [];
    //
    angular.forEach(this.giftCardDetails, function (item, key) {
      if (item.isCardVerified && item.amount > 0) {

        $ctrl.$spinner.show('appSpinner');
        var giftCards = {

          "giftCard": item.cardNumber,
          "amount": item.amount,
          "pin": item.cvv
        };
        $ctrl.$spinner.hide('appSpinner');
        giftCardsRequest.push(giftCards);
      }
    });

    // getGiftCardPreAuthRequest
    if (this.isAllowToPayOnlyWithGiftCards) {
      this.$spinner.show('appSpinner');
      var getGiftCardPreAuthRequest = {
        "getGiftCardPreAuthCardRequestList": giftCardsRequest
      };
      var data = {
        "getGiftCardPreAuthRequest": getGiftCardPreAuthRequest
      };
      data.orderId = this.$stateParams.orderId;
      data.totalAmount = this.orderAmount;
      this.$order.paymentUsingGiftCards(data)
        .then(
          success => {
            // this.$spinner.show('appSpinner');

            if (success.data.successCode === '0' && success.data.message === 'Approved') {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.success', {
                orderId: this.$stateParams.orderId,
                isCardSaved: true
              });

            }
            else {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.failure', {
                orderId: this.$stateParams.orderId,
                logString: JSON.stringify(success),
                reasonCode: success.data.successCode
              });
            }
          },
          error => {
            this.$spinner.hide('appSpinner');
            this.$state.go('payment.failure', {
              orderId: this.$stateParams.orderId,
              logString: JSON.stringify(error),
              reasonCode: error.data.successCode
            });
          }
        )
        .catch(err => {
          this.$auth.printCustomerGenericLogs(err);
        })
        .finally(() => {
          this.$spinner.hide('appSpinner');
          this.isCallingAPI = false;
        });
    }
    else {
      let cardNumber = this.cardInfo.filter(card => card.id === this.cardId)[0].cardNumber;
      var giftCardData = {
        "getGiftCardPreAuthCardRequestList": giftCardsRequest
      };
      var dataRequest = {
        "orderId": this.$stateParams.orderId,
        "cardNumber": cardNumber,
        "cardId": this.cardId,
        "getGiftCardPreAuthRequest": giftCardData
      };

      // Heartland
      if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
        this.$spinner.show('appSpinner');
        this.$order.paymentSubmitHeartland(dataRequest)

          .then(
            success => {
              this.$spinner.hide('appSpinner');
              if (success.data.successCode === '00' && success.data.message === this.heartand_Approval) {
                this.$state.go('payment.success', {
                  orderId: this.$stateParams.orderId,
                  isCardSaved: true
                });
              }
              else {
                this.$state.go('payment.failure', {
                  orderId: this.$stateParams.orderId,
                  logString: JSON.stringify(success),
                  reasonCode: success.data.successCode
                });
              }
            },
            error => {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.failure', {
                orderId: this.$stateParams.orderId,
                logString: JSON.stringify(error),
                reasonCode: error.data.successCode
              });
            }
          )
          .catch(err => {
            this.$auth.printCustomerGenericLogs(err);
          })
          .finally(() => {
            this.$spinner.hide('appSpinner');
            this.isCallingAPI = false;
          });

      } 

      // Tsys
      else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.tsys) {
        this.$spinner.show('appSpinner');
        this.$order.paymentSubmitTsys(dataRequest)

          .then(
            success => {
              this.$spinner.hide('appSpinner');
              if (success.data.successCode === '00' && success.data.message === this.heartand_Approval) {
                this.$state.go('payment.success', {
                  orderId: this.$stateParams.orderId,
                  isCardSaved: true
                });
              }
              else {
                this.$state.go('payment.failure', {
                  orderId: this.$stateParams.orderId,
                  logString: JSON.stringify(success),
                  reasonCode: success.data.successCode
                });
              }
            },
            error => {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.failure', {
                orderId: this.$stateParams.orderId,
                logString: JSON.stringify(error),
                reasonCode: error.data.successCode
              });
            }
          )
          .catch(err => {
            this.$auth.printCustomerGenericLogs(err);
          })
          .finally(() => {
            this.$spinner.hide('appSpinner');
            this.isCallingAPI = false;
          });

      }

       // Moneris
       else if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.moneris) {
        this.$spinner.show('appSpinner');
        this.$order.paymentSubmitMoneris(dataRequest)
          .then(
            success => {
              this.$spinner.hide('appSpinner');
              if (success.data.successCode === '00' && success.data.message === this.heartand_Approval) {
                this.$state.go('payment.success', {
                  orderId: this.$stateParams.orderId,
                  isCardSaved: true
                });
              }
              else {
                this.$state.go('payment.failure', {
                  orderId: this.$stateParams.orderId,
                  logString: JSON.stringify(success),
                  reasonCode: success.data.successCode
                });
              }
            },
            error => {
              this.$spinner.hide('appSpinner');
              this.$state.go('payment.failure', {
                orderId: this.$stateParams.orderId,
                logString: JSON.stringify(error),
                reasonCode: error.data.successCode
              });
            }
          )
          .catch(err => {
            this.$auth.printCustomerGenericLogs(err);
          })
          .finally(() => {
            this.$spinner.hide('appSpinner');
            this.isCallingAPI = false;
          });

      }

      // Worldpay
      else {
        this.$spinner.show('appSpinner');
        this.$order.paymentSubmit(this.$stateParams.orderId, this.cardId, cardNumber, giftCardData)
          .then(
            success => {
              this.$spinner.hide('appSpinner');
              if (success.data.successCode === '0' && success.data.message === 'Approved') {
                this.$state.go('payment.success', {
                  orderId: this.$stateParams.orderId,
                  isCardSaved: true
                });
              }
              else {
                this.$state.go('payment.failure', {
                  orderId: this.$stateParams.orderId,
                  logString: JSON.stringify(success),
                  reasonCode: success.data.successCode
                });
              }
            },
            error => {
              if (error.data){ 
                this.$spinner.hide('appSpinner');
                if (error.data.errorCode && error.data.errorCode===704) {
                  this.$state.go('cart');
                  this.$toaster.pop('success', error.data.message);
                } else {
                  this.$state.go('payment.failure', {
                  orderId: this.$stateParams.orderId,
                  logString: JSON.stringify(error)
                  });
                }
              } 
            }
          )
          .catch(err => {
            this.$auth.printCustomerGenericLogs(err);
          })
          .finally(() => {
            this.$spinner.hide('appSpinner');
            this.isCallingAPI = false;
          });
      }
    }
  }


  paymentByNewCard() {
    let device = this.getDeviceParameter();
    this.isCallingAPI = true;
    // Un comment when terms and condition button changes needed
    // if(!this.agreement)
    // {
    //   this.$toaster.pop('success', 'Please Select Terms and Conditions');
    //   this.isCallingAPI = false;
    //   return;
    // }
    var giftCardsRequest = [];
    angular.forEach(this.giftCardDetails, function (item, key) {
      if (item.isCardVerified && item.amount > 0) {
        var giftCards = {
          "giftCard": item.cardNumber,
          "amount": item.amount,
          "pin": item.cvv
        };
        giftCardsRequest.push(giftCards);
      }
    });
    var data = {
      "getGiftCardPreAuthCardRequestList": giftCardsRequest
    };

    // New card payment by heartland
    if (this.paymentType === this.APP.ORDER.PAYMENT_TYPE.heartLand) {
      this.$spinner.show('appSpinner');

      // Function to save giftcardRequest in orderservice
      // this.$order.setGiftCardRequest(giftCardsRequest);

      this.showHeartLandPage = true;
      this.giftCardsRequest = giftCardsRequest;
      // this.callHeartLandPage(giftCardsRequest);
      this.callHeartLandCustom(giftCardsRequest);
      this.$spinner.hide('appSpinner');
    }
    // New card payment by Tsys
    else if(this.paymentType === this.APP.ORDER.PAYMENT_TYPE.tsys){
      this.$spinner.show('appSpinner');
      this.showHeartLandPage = false;
      this.giftCardsRequest = giftCardsRequest;
      this.callTsysCustom(giftCardsRequest);
      this.$spinner.hide('appSpinner');
    }
     // New card payment by Moneris
     else if(this.paymentType === this.APP.ORDER.PAYMENT_TYPE.moneris){
      this.$spinner.show('appSpinner');
      this.showHeartLandPage = false;
      this.giftCardsRequest = giftCardsRequest;
      this.callMonerisCustom(giftCardsRequest);
      this.$spinner.hide('appSpinner');
    }
    // New card payment by Worldpay
    else 
    {
      this.$spinner.show('appSpinner');
      this.$order.initializePayment(this.$stateParams.orderId, device, data)
        .then(
          success => {
            this.$spinner.hide('appSpinner');
            if (!success.data.additionalInfo || success.data.additionalInfo === 'Nil') {
              this.$toaster.pop('success', 'Unable to process your payment currently. Please try again later.');
              return;
            }
            this.goToMerchantPage(success.data);
          },
          err => {
            // console.log(err);
            if (err.data){ 
              if (err.data.errorCode && err.data.errorCode===704) {
                this.$state.go('cart');
              }
          }
            this.$spinner.hide('appSpinner');
            this.$toaster.pop('success', err.data.message);
            this.isCallingAPI = false;
          }
        )
        .catch(err => {
          this.$auth.printCustomerGenericLogs(err);
        });
    }
  }

  goToMerchantPage(data, method) {
    method = method || 'post';

    let form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', data.message);

    let payIdField = document.createElement('input');
    payIdField.setAttribute('type', 'hidden');
    payIdField.setAttribute('name', 'PaymentID');
    payIdField.setAttribute('value', data.additionalInfo);
    form.appendChild(payIdField);

    let returnMethodField = document.createElement('input');
    returnMethodField.setAttribute('type', 'hidden');
    returnMethodField.setAttribute('name', 'ReturnMethod');
    returnMethodField.setAttribute('value', 'POST');
    form.appendChild(returnMethodField);

    document.body.appendChild(form);
    form.submit();
  }

  getDeviceParameter() {
    if (window.innerWidth <= 576) {
      return 'm';
    }
    else if (window.innerWidth > 576 && window.innerWidth <= 768) {
      return 't';
    }
    else if (window.innerWidth > 768) {
      return 'd';
    }
  }

  addCard(index) {
    this.isAllowedToAddCard();
    this.canZeroDollarErplyTransaction();
    if (this.isAllowedToAdd) {
      if (this.orderAmount <= this.getTotalGiftCardAddedAmount()) {
        this.$toaster.pop('success', 'Gift Card amount has reached the limit');
      } else {
        var isCardVerified = this.giftCardDetails[index].isCardVerified;
        if (isCardVerified) {
          if (this.giftCardDetails.length < this.MaxGiftCardsDetails) {
            this.giftCardDetails.push(this.getEmptyCardDetails());
          }
        } else {
          this.$toaster.pop('success', 'Please apply the card');
        }
      }
    } else {
      this.$toaster.pop('success', 'Please apply the card');
    }
  }

  removeCard(index) {
    var total = 0;
    this.isAllowedToAdd = true;
    if (this.giftCardDetails.length >= 1) {
      // this.giftCardDetails.push(this.getEmptyCardDetails());
      if (this.giftCardDetails[index].isCardVerified) {
        var removeIndex = this.giftCardNumbers.indexOf(this.giftCardDetails[index].cardNumber);
        this.giftCardNumbers.splice(removeIndex, 1);
      }
      this.giftCardDetails.splice(index, 1);
      // Pushing empty if all giftcards removed
      if (this.giftCardDetails.length < 1) {
        this.giftCardDetails.push(this.getEmptyCardDetails());
      }
    }
    var previousTotalAmount = 0.00;
    for (var i = 0; i < this.giftCardDetails.length; i++) {
      console.log(this.giftCardDetails[i].actualAmount);
      if (this.giftCardDetails[i].actualAmount > 0) {
        total = total + this.giftCardDetails[i].actualAmount;
        if (this.orderAmount >= total) {
          this.isAllowedToAdd = true;
          this.giftCardDetails[i].amount = this.getRoundoffValue(this.giftCardDetails[i].actualAmount,this.toDecimalPlaces);
          previousTotalAmount = previousTotalAmount + this.giftCardDetails[i].amount;
        } else {
          if(this.orderAmount-previousTotalAmount>this.giftCardDetails[i].actualAmount){
            this.isAllowedToAdd = true;
            this.giftCardDetails[i].amount =this.getRoundoffValue(this.giftCardDetails[i].actualAmount,this.toDecimalPlaces);
          }
          else {
            this.isAllowedToAdd = false;
            this.giftCardDetails[i].amount = this.getRoundoffValue(this.orderAmount - previousTotalAmount,this.toDecimalPlaces);
          }
        }
      }
    }
    if(this.orderAmount>0){
      this.isAllowToPayOnlyWithGiftCards = (this.getTotalGiftCardAddedAmount() == this.orderAmount);
    }
    this.canZeroDollarErplyTransaction();
  }

  getRoundoffValue(number, places){
    // console.log(" number.toFixed(places) : "+  number.toFixed(places));
    return parseFloat(number.toFixed(places));
  }

  getEmptyCardDetails() {
    return {
      "cardNumber": '',
      "cvv": '',
      "isCardVerified": false,
      "amount": 0.00,
      "isAllowedToAdd": true,
      "actualAmount": 0.00
    };
  }

  verifyCard(index) {
    this.waitUntilVerify = true;
    var giftCardExits = this.giftCardNumbers.filter(gift => gift === this.giftCardDetails[index].cardNumber);
    // console.log("giftCardExits",giftCardExits);
    var data = {
      "giftCard": this.giftCardDetails[index].cardNumber
    };
    if (giftCardExits.length != 0) {
      this.waitUntilVerify = false;
      this.$toaster.pop('success', 'The gift card has added already');
    } else {
      this.validateGiftCardDetails(data, index);
    }
    //  this.validateGiftCardDetails(data,index);
  }

  validateGiftCardDetails(data, index) {
    this.$order.validateGiftCardDetails(data)
      .then(
        success => {
          // console.log("success", success);
          if (success.data.amount > 0) {
            this.giftCardDetails[index].actualAmount = success.data.amount;
            this.giftCardDetails[index].amount = this.getRoundoffValue(this.validateBalanceAmount(index, success.data.amount),this.toDecimalPlaces);
            this.giftCardDetails[index].isCardVerified = true;
            this.giftCardNumbers.push(this.giftCardDetails[index].cardNumber);
          } else {
            this.$toaster.pop('success', "Entered Gift card has zero balance and hence can't be applied");
          }
          this.isAllowedToAddCard();
          if(this.orderAmount>0){
            this.isAllowToPayOnlyWithGiftCards = (this.getTotalGiftCardAddedAmount() == this.orderAmount);
          }
          this.waitUntilVerify = false;
        },
        error => {
          this.waitUntilVerify = false;
          this.$toaster.pop('success', error.data.message);
          // console.log("error", error);
          this.giftCardDetails[index].amount = 0.00;
          this.giftCardDetails[index].isCardVerified = false;
        }
      )
      .catch(err => {
        this.$auth.printCustomerGenericLogs(err);
      })
      .finally(() => this.$spinner.hide('appSpinner'));
  }

  isAllowedToAddCard() {
    // Allow to show add or remove if only one giftcard
    if (this.giftCardDetails.length == 1) {
      this.isAllowedToAdd = true;
      this.isAllowedToRemove = true;
    } else {
      var count = 0;
      // Validate to add card across all the giftcards
      angular.forEach(this.giftCardDetails, function (item, key) {
        if (item) {
          count = count + (item.isCardVerified ? 1 : 0);
        }
      });
      // console.log("count",count);
      // console.log(this.giftCardDetails.length);
      if (count == this.giftCardDetails.length) {
        this.isAllowedToAdd = true;
      } else {
        this.isAllowedToAdd = false;
      }
    }
  }

  validateBalanceAmount(index, amount) {
    var total = 0.00;
    var giftCardAmountAddedSofar = 0.00;
    angular.forEach(this.giftCardDetails, function (item, key) {
      if (item) {
        total = total + item.amount;
      }
    });
    giftCardAmountAddedSofar = total;
    total = total + amount;
    if (this.orderAmount < amount) {
      if(this.orderAmount-giftCardAmountAddedSofar<amount){
        this.isAllowedToAdd = false;
        return this.orderAmount-giftCardAmountAddedSofar;
      } else {
        this.isAllowedToAdd = false;
        return this.orderAmount;
      }
    }
    else if (this.orderAmount >= total) {
      this.isAllowedToAdd = true;
      return amount;
    }
    else {
      if (total - this.orderAmount > amount) {
        this.isAllowedToAdd = false;
        return amount;
      } else {
        this.isAllowedToAdd = false;
        return amount - (total - this.orderAmount);
      }
    }
  }

  isMobileOnly() {
    return this.$auth.isMobileDevice();
  }

  getTotalGiftCardAddedAmount() {
    var total = 0.00;
    angular.forEach(this.giftCardDetails, function (item, key) {
      if (item) {
        total = total + item.amount;
      }
    });
    return this.getRoundoffValue(total,this.toDecimalPlaces);
    // return total;
  }

  // isIpad() {
  //   return this.$order.isIpad();
  // }

  isIpad() {
    return (this.$window.innerWidth < 1248 && this.$window.innerWidth > 767);
  }

  isIpadPotrait() {
    if (this.isIpad()) {
      return (this.$window.innerWidth < 785);
    } else {
      return false;
    }
  }

  isIpadLandscape() {
    if (this.isIpad()) {
      return (this.$window.innerWidth > 1037);
    } else {
      return false;
    }
  }

  cartContainsOnlyGift() {
    const totalItemsInCart = this.cartDetail.cartItems.length;
    var isCardhasGiftOnly = this.cartContainsGiftCard();
    return isCardhasGiftOnly && (totalItemsInCart === this.cartContainsGiftCard());
  }

  cartContainsGiftCard() {
    return this.cartDetail.cartItems
      ? this.cartDetail.cartItems.filter(item => {
        var masterCode = item.item.masterProduct.masterCode;
        var seriesNumber = masterCode.charAt(0);
        var categoryId = item.item.masterProduct.category.id;
        return seriesNumber === '9' && categoryId === this.isMiscelleneousCategory;
      }).length
      : false;
  }

  
  callHeartLandCustom(giftCardsRequest){
    this.giftCardsRequest = giftCardsRequest;
    this.showHeartLandPage = true;
    this.$state.go('payment-detail', { giftcardReq: this.giftCardsRequest });
  }

  callTsysCustom(giftCardsRequest){
    this.giftCardsRequest = giftCardsRequest;
    this.showHeartLandPage = true;
    this.$state.go('tsys-payment', { giftcardReq: this.giftCardsRequest });
  }

  callMonerisCustom(giftCardsRequest){
    this.giftCardsRequest = giftCardsRequest;
    this.showHeartLandPage = true;
    this.$state.go('moneris-payment', { giftcardReq: this.giftCardsRequest });
  }

  canZeroDollarErplyTransaction() {
    console.log("this.giftCardDetails[0].isCardVerified : ",this.giftCardDetails[0].isCardVerified);
    /*
    if (this.orderAmount == 0.00 && this.isErplyStore && !this.isAllowToPayOnlyWithGiftCards) {
      if((this.giftCardDetails.length == 1 && !this.giftCardDetails[0].isCardVerified)){
        this.allowErplyZeroDollarTrasaction = true;
      } else {
        this.allowErplyZeroDollarTrasaction = false;
      }
    } else {
      this.allowErplyZeroDollarTrasaction = false;
    }
    */
  }

  doErplyZeroDollarTransaction() {
    this.$spinner.show('appSpinner');
    this.$order.doErplyZeroDollarTransaction(this.$stateParams.orderId)
    .then(
      success => {
        // this.$spinner.show('appSpinner');

        if (success.data.successCode === '0' && success.data.message === 'Approved') {
          this.$spinner.hide('appSpinner');
          this.$state.go('payment.success', {
            orderId: this.$stateParams.orderId,
            isCardSaved: true
          });

        }
        else {
          this.$spinner.hide('appSpinner');
          this.$state.go('payment.failure', {
            orderId: this.$stateParams.orderId,
            logString: JSON.stringify(success),
            reasonCode: success.data.successCode
          });
        }
      },
      error => {
        this.$spinner.hide('appSpinner');
        this.$state.go('payment.failure', {
          orderId: this.$stateParams.orderId,
          logString: JSON.stringify(error),
          reasonCode: error.data.successCode
        });
      }
    )
    .catch(err => {
      this.$auth.printCustomerGenericLogs(err);
    })
    .finally(() => {
      this.$spinner.hide('appSpinner');
      this.isCallingAPI = false;
    });
  }

  toggleSaveUserCard(saveCard){
    console.log("SaveCard : "+ saveCard);
    this.$order.canSaveUserCard(saveCard);
  }

  isGuestProfile(){
    return this.profile.customer.isGuest;
  }

}


// WEBPACK FOOTER //
// ./src/app/order/payment/card-detail.js